/**
 * Created by dushyantha on 10/10/16.
 */
'use strict';

(function () {
    angular
        .module('trainingSchedule')
        .component('trainingScheduleComponent', {
            templateUrl: 'training-schedule/components/training-schedule-component.tpl.html',
            controller: function ($scope,EventManagerService,PopupManager, $timeout, $window, StorageServices,TabService,CommonLogicService,$sce,MessageService) {
                var vm  =  this;
                vm.bufferNumberOfRecords = 10;
                vm.rowHeightInPixcel = 50;
                vm.headerHeight = 110;
                vm.pageSize= 200;
                vm.isElasticLoadingVisible = false;
                vm.canvasHeight = 0;
                vm.canvasWidth = 0;
                vm.reportUrl = null;
                vm.resultList = [];
                vm.screen_right_panel = 0;
                vm.comHeight = window.innerHeight - (70 + 42 + 40 + 80);
                vm.expiries = [];

                EventManagerService.registerEventListener(EventManagerService.EVENT.SHOW_HIDE_LOADING, showHideElasticLoading);
              EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_PROGRAME.ADD_NEW_TRAINING, showHideElasticLoading);

                function initDivMeasurements() {
        			$timeout(function(){
        				//70 (title bar height) + (toolbar height) + (Title height) + 55 (tab header)+47 (grid table header height)
        				vm.heightGridData = 70 + angular.element('.training-discrepancy').height() + angular.element('.training-admin-screen-header').height() + 55;
        				updateDivMeasurements();
        			})
        		}

        		function updateDivMeasurements() {
        			$timeout(function(){
        				vm.canvasHeight = $window.innerHeight - vm.heightGridData;
        				//70 (Side panel)
        				vm.canvasWidth = $window.innerWidth - 70;
        			})
        		}

        		angular.element($window).bind('resize', function(){
        			initDivMeasurements();
                });

        		initDivMeasurements();
                function completeDelete(param){
                    if(!!param){
                        vm.deleteTraining();
                    }
                }

                function deleteTrainingConfirmation(param){
                	if(!!param && !!param.assignedTrainees){
                        var details = {
                            title: 'Confirmation',
                            messages: ['Selected record will be Deleted. Do you wish to Continue?']

                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, completeDelete);
                    } else {
                    	completeDelete(param);
                    }
                }
                vm.deleteTrainingSlot = function(training) {
                    vm.selectedRecord = {};
                    angular.forEach(vm.trainingSchedule, function (schedule) {
                        schedule.isSelected = false;

                    });
                    training.isSelected = true;
                    deleteTrainingConfirmation(training);
                };

              vm.onClick = function () {
                var _loadTrainingDiscrepancyParams = {
                  fromDate: vm.searchParam.startDate,
                  toDate: vm.searchParam.endDate,
                  acType: (vm.searchParam.aircraftModel !=null) ? vm.searchParam.aircraftModel : "ANY",
                  category: (vm.searchParam.trainingProCategory != null) ? vm.searchParam.trainingProCategory : "ANY"

                };

                var navigateToTrainingDiscrepancy = function(paramToSend){
                  var tabName = 'trainingDiscrepancy';
                  StorageServices.setTabData(tabName,'_loadTrainingDiscrepancyParams', paramToSend);
                  TabService.gotoTab(tabName);
                };
                navigateToTrainingDiscrepancy(_loadTrainingDiscrepancyParams);
              };

              function showHideElasticLoading(data) {
                    if (data.target == 'trainingSchedule') {
                        vm.isElasticLoadingVisible = data.flag;

                        if(data.flag && angular.element('.elasticLoadingOverlay').length == 0) {
                        	var overlay = angular.element('<div class="elasticLoadingOverlay"></div>');

                        	overlay.css({
                        	    'background-color': '#eee',
                        	    'opacity': '0.8',
                        	    'position': 'absolute',
                        	    'left': '0px',
                        	    'top': '0px',
                        	    'z-index': '1100',
                        	    'height': '100%',
                        	    'width': '100%',
                        	    'overflow': 'hidden',
                        	    'background-image': "url('ajax-loader.gif')",
                        	    'background-position': 'center',
                        	    'background-repeat': 'no-repeat',
                        	    });
                        	angular.element(document.body).append(overlay);
                        	angular.element('.right-section').css('overflow', 'hidden');
                    	} else if (data.flag) {
                    	    angular.element('.elasticLoadingOverlay').removeClass('ng-hide');
                    	    angular.element('.right-section').css('overflow', 'hidden');
                    	} else {
                    	    angular.element('.elasticLoadingOverlay').addClass('ng-hide');
                    	    angular.element('.right-section').css('overflow', 'auto');
                    	}
                    }
                }

              vm.printTrainingSlotData = function (training) {
                printTrainingSlot(training);
              };


              // set search param map
              function getSearchParamMap(param) {
                var searchParamMap = {};

                searchParamMap["courseTitle"] = param.trainingSlot;
                searchParamMap["startDate"] = param.fromDate;
                searchParamMap["endDate"] = param.toDate;
                searchParamMap["venue"] = param.trainingLocationDesc;
                searchParamMap["tSlotId"] = param.trainingSlotId;
                searchParamMap["referrer"] = window.location.origin;

                return searchParamMap;
              }

              function printTrainingSlot(param){
               var url = CommonLogicService.getReportUrl('trainingSchedule.rptdesign&__format=pdf',getSearchParamMap(param));
                vm.reportUrl = $sce.trustAsResourceUrl(url);
                window.open(vm.reportUrl);
               }

              vm.clickOnTraining = function (training) {
                    vm.selectedRecord = {};
                    angular.forEach(vm.trainingSchedule, function (schedule) {
                            schedule.isSelected = false;
                    });
                    training.isSelected = true;
                    vm.selectedRecord = training;
                    vm.loadTrainingCategory({'selectedItem':training});
                };

              vm.exportTrainingSlotData = function (training) {
                exportTrainingSlot(training);
              };

              function exportTrainingSlot(param){
                var url = CommonLogicService.getReportUrl('trainingSchedule.rptdesign&__format=xls',getSearchParamMap(param));
                vm.reportUrl = $sce.trustAsResourceUrl(url);
                window.open(vm.reportUrl);
              }

              vm.exportExcel = function () {
                // Check if ExcelJS library is loaded (preferred for styling)
                if (typeof ExcelJS !== 'undefined') {
                  console.log('Using ExcelJS for export with styling support');
                  exportWithExcelJS();
                } else if (typeof XLSX !== 'undefined') {
                  console.log('Fallback to XLSX (styling not supported)');
                  // Fallback to XLSX but note styling limitations
                  exportWithXLSX();
                } else {
                  MessageService.error('Excel export library is not loaded. Please refresh the page and try again.');
                  return;
                }
              };

              function exportWithExcelJS() {
                console.log('ExcelJS export started');
                var mergeInfo = createSearchResultList();
                console.log('Merge info:', mergeInfo);

                try {
                  // Create a new workbook and worksheet
                  var workbook = new ExcelJS.Workbook();
                  var worksheet = workbook.addWorksheet('Training Schedule');

                  // Headers
                  var headers = [
                    '#', 'A/C', 'Category', 'Location', 'Description',
                    'Start(Local)', 'End(Local)', 'Pattern', 'Program', 'Program Details',
                    'Trainer Hub','Trainer ID','Crew Type','Trainer(s)',
                    'Trainee Hub','Trainee ID','Crew Type', 'Trainees',
                    'StandIn/Observers Hub','StandIn/Observers ID','Crew Type', 'StandIn/Observers'
                  ];

                  // Add header row with styling
                  var headerRow = worksheet.addRow(headers);
                  headerRow.font = {bold: true};
                  headerRow.alignment = {vertical: 'middle', horizontal: 'center'};
                  headerRow.height = 25;

                  // Add data rows
                  for (var i = 0; i < vm.resultList.length; i++) {
                    var row = vm.resultList[i];
                    var rowData = [
                      row.id,
                      row.aircraftModel,
                      row.trainingProgCategory,
                      row.trainingLocation,
                      row.trainingSlot,
                      row.start,
                      row.endData,
                      row.isPartOfPattern,
                      row.trainingProgram,
                      row.subProgramCode,
                      row.trainerHub,
                      row.trainerId,
                      row.trainerCrewType,
                      row.trainersNames,
                      row.traineeHub,
                      row.traineeId,
                      row.traineeCrewType,
                      row.traineesList,
                      row.observerHub,
                      row.observerId,
                      row.observerCrewType,
                      row.observerList
                    ];

                    var excelRow = worksheet.addRow(rowData);
                    excelRow.height = 20;
                  }

                  console.log('Total rows added:', vm.resultList.length);

                  // Apply merges and alignment for nested rows
                  if (mergeInfo.length > 0) {
                    for (var m = 0; m < mergeInfo.length; m++) {
                      var merge = mergeInfo[m];
                      console.log('Processing merge:', merge);

                      // Only merge if there are multiple rows for this schedule
                      if (merge.rowCount > 1) {
                        // Merge cells for columns 1-10 (main schedule data columns)
                        // ExcelJS uses 1-based indexing, and +1 for header row
                        for (var col = 1; col <= 10; col++) {
                          var startRow = merge.startRow + 1; // +1 for header
                          var endRow = merge.endRow + 1;

                          try {
                            worksheet.mergeCells(startRow, col, endRow, col);
                            console.log('Merged cells: ', startRow, col, endRow, col);
                          } catch (e) {
                            console.error('Error merging cells:', e);
                          }
                        }
                      }
                    }
                  }

                  // Apply alignment to ALL cells after merging
                  worksheet.eachRow(function(row, rowNumber) {
                    row.eachCell(function(cell, colNumber) {
                      if (rowNumber === 1) {
                        // Header row
                        cell.alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                        cell.font = {bold: true};
                      } else {
                        // Data rows - apply vertical middle alignment
                        cell.alignment = {vertical: 'middle', horizontal: 'left', wrapText: false};
                      }
                    });
                  });

                  console.log('Alignment applied to all cells');

                  // Set column widths
                  worksheet.columns = [
                    {width: 8},   // #
                    {width: 10},  // A/C
                    {width: 15},  // Category
                    {width: 20},  // Location
                    {width: 30},  // Description
                    {width: 18},  // Start(Local)
                    {width: 18},  // End(Local)
                    {width: 10},  // Pattern
                    {width: 20},  // Program
                    {width: 20},  // Program Details
                    {width: 15},  // Trainer Hub
                    {width: 12},  // Trainer ID
                    {width: 12},  // Trainer Crew Type
                    {width: 25},  // Trainer(s)
                    {width: 15},  // Trainee Hub
                    {width: 12},  // Trainee ID
                    {width: 12},  // Trainee Crew Type
                    {width: 25},  // Trainees
                    {width: 15},  // StandIn/Observers Hub
                    {width: 12},  // StandIn/Observers ID
                    {width: 12},  // StandIn/Observers Crew Type
                    {width: 25}   // StandIn/Observers
                  ];

                  console.log('Starting buffer write...');

                  // Generate Excel file and trigger download
                  workbook.xlsx.writeBuffer().then(function(buffer) {
                    console.log('Buffer created successfully');
                    var blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'trainingScheduleData.xlsx';
                    document.body.appendChild(a);
                    a.click();

                    // Cleanup
                    setTimeout(function() {
                      document.body.removeChild(a);
                      window.URL.revokeObjectURL(url);
                    }, 100);

                    console.log('Export completed successfully');
                    clearData();
                  }).catch(function(error) {
                    console.error('Export error:', error);
                    MessageService.error('Failed to export Excel file: ' + error.message);
                    clearData();
                  });
                } catch (error) {
                  console.error('ExcelJS error:', error);
                  MessageService.error('Failed to create Excel file: ' + error.message);
                  clearData();
                }
              }

              function exportWithXLSX() {
                var mergeInfo = createSearchResultList();

                // Helper function to convert column number to letter (A, B, C, etc.)
                function columnToLetter(column) {
                  var temp, letter = '';
                  while (column > 0) {
                    temp = (column - 1) % 26;
                    letter = String.fromCharCode(temp + 65) + letter;
                    column = (column - temp - 1) / 26;
                  }
                  return letter;
                }

                // Helper function to create cell reference (A1, B2, etc.)
                function cellRef(row, col) {
                  return columnToLetter(col + 1) + (row + 1);
                }

                // Create worksheet manually
                var ws = {};
                var range = {s: {c: 0, r: 0}, e: {c: 21, r: 0}};

                // Headers
                var headers = [
                  '#', 'A/C', 'Category', 'Location', 'Description',
                  'Start(Local)', 'End(Local)', 'Pattern', 'Program', 'Program Details',
                  'Trainer Hub','Trainer ID','Crew Type','Trainer(s)',
                  'Trainee Hub','Trainee ID','Crew Type', 'Trainees',
                  'StandIn/Observers Hub','StandIn/Observers ID','Crew Type', 'StandIn/Observers'
                ];

                // Add header row
                for (var col = 0; col < headers.length; col++) {
                  ws[cellRef(0, col)] = {v: headers[col], t: 's'};
                }

                // Add data rows
                for (var i = 0; i < vm.resultList.length; i++) {
                  var row = vm.resultList[i];
                  var rowIndex = i + 1;

                  var rowData = [
                    row.id,
                    row.aircraftModel,
                    row.trainingProgCategory,
                    row.trainingLocation,
                    row.trainingSlot,
                    row.start,
                    row.endData,
                    row.isPartOfPattern,
                    row.trainingProgram,
                    row.subProgramCode,
                    row.trainerHub,
                    row.trainerId,
                    row.trainerCrewType,
                    row.trainersNames,
                    row.traineeHub,
                    row.traineeId,
                    row.traineeCrewType,
                    row.traineesList,
                    row.observerHub,
                    row.observerId,
                    row.observerCrewType,
                    row.observerList
                  ];

                  for (var col = 0; col < rowData.length; col++) {
                    var cellValue = rowData[col];
                    if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
                      ws[cellRef(rowIndex, col)] = {v: cellValue, t: 's'};
                    } else {
                      ws[cellRef(rowIndex, col)] = {v: '', t: 's'};
                    }
                  }

                  // Update range
                  if (rowIndex > range.e.r) range.e.r = rowIndex;
                }

                // Set range
                ws['!ref'] = cellRef(range.s.r, range.s.c) + ':' + cellRef(range.e.r, range.e.c);

                // Add merge cells for nested rows
                if (mergeInfo.length > 0) {
                  ws['!merges'] = [];
                  for (var m = 0; m < mergeInfo.length; m++) {
                    var merge = mergeInfo[m];
                    // Only merge if there are multiple rows for this schedule
                    if (merge.rowCount > 1) {
                      // Merge cells for columns 0-9 (main schedule data columns)
                      for (var col = 0; col < 10; col++) {
                        ws['!merges'].push({
                          s: {r: merge.startRow, c: col},
                          e: {r: merge.endRow, c: col}
                        });
                      }
                    }
                  }
                }

                // Set column widths
                ws['!cols'] = [
                  {wch: 8},   // #
                  {wch: 10},  // A/C
                  {wch: 15},  // Category
                  {wch: 20},  // Location
                  {wch: 30},  // Description
                  {wch: 18},  // Start(Local)
                  {wch: 18},  // End(Local)
                  {wch: 10},  // Pattern
                  {wch: 20},  // Program
                  {wch: 20},  // Program Details
                  {wch: 15},  // Trainer Hub
                  {wch: 12},  // Trainer ID
                  {wch: 12},  // Trainer Crew Type
                  {wch: 25},  // Trainer(s)
                  {wch: 15},  // Trainee Hub
                  {wch: 12},  // Trainee ID
                  {wch: 12},  // Trainee Crew Type
                  {wch: 25},  // Trainees
                  {wch: 15},  // StandIn/Observers Hub
                  {wch: 12},  // StandIn/Observers ID
                  {wch: 12},  // StandIn/Observers Crew Type
                  {wch: 25}   // StandIn/Observers
                ];

                // Create workbook
                var wb = {
                  SheetNames: ['Training Schedule'],
                  Sheets: {'Training Schedule': ws}
                };

                // Generate Excel file and trigger download (browser-compatible)
                try {
                  // Write workbook to binary string
                  var wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});

                  // Convert binary string to array buffer
                  function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i < s.length; i++) {
                      view[i] = s.charCodeAt(i) & 0xFF;
                    }
                    return buf;
                  }

                  // Create blob and download link
                  var blob = new Blob([s2ab(wbout)], {type: 'application/octet-stream'});
                  var url = window.URL.createObjectURL(blob);
                  var a = document.createElement('a');
                  a.href = url;
                  a.download = 'trainingScheduleData.xlsx';
                  document.body.appendChild(a);
                  a.click();

                  // Cleanup
                  setTimeout(function() {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                  }, 100);

                  clearData();
                } catch (e) {
                  MessageService.error('Failed to export Excel file: ' + e.message);
                  clearData();
                }
              }

              function createSearchResultList() {
                var mergeInfo = [];
                var currentRowIndex = 0;

                for (var i = 0; i < vm.trainingSchedule.length; i++) {
                  var schedule = vm.trainingSchedule[i];

                  // Get arrays of names
                  var trainers = !!schedule.assignedTrainers ? schedule.assignedTrainers : [];
                  var trainees = !!schedule.assignedTrainees ? schedule.assignedTrainees : [];
                  var observers = !!schedule.assignedObservers ? schedule.assignedObservers : [];

                  // Calculate rows needed: Cartesian product of trainers × trainees
                  // If either trainers or trainees is empty, we need at least 1 row to show the schedule
                  var maxRows;
                  if (trainers.length > 0 && trainees.length > 0) {
                    maxRows = trainers.length * trainees.length;
                  } else if (trainers.length > 0) {
                    maxRows = trainers.length;
                  } else if (trainees.length > 0) {
                    maxRows = trainees.length;
                  } else {
                    maxRows = Math.max(1, observers.length);
                  }

                  // Store merge info for this schedule
                  var startRow = currentRowIndex + 1; // +1 because row 0 is header
                  var endRow = startRow + maxRows - 1;

                  mergeInfo.push({
                    startRow: startRow,
                    endRow: endRow,
                    rowCount: maxRows
                  });

                  // Create rows with Cartesian product of trainers × trainees
                  for (var j = 0; j < maxRows; j++) {
                    var row = {
                      id: '',
                      aircraftModel: '',
                      trainingProgCategory: '',
                      trainingLocation: '',
                      trainingSlot: '',
                      start: '',
                      endData: '',
                      isPartOfPattern: '',
                      trainingProgram: '',
                      subProgramCode: '',
                      trainerHub: '',
                      trainerId: '',
                      trainerCrewType: '',
                      trainersNames: '',
                      traineeHub: '',
                      traineeId: '',
                      traineeCrewType: '',
                      traineesList: '',
                      observerHub: '',
                      observerId: '',
                      observerCrewType: '',
                      observerList: ''
                    };

                    // First row contains schedule data
                    if (j === 0) {
                      row.id = schedule.id;
                      row.aircraftModel = schedule.airCraftType;
                      row.trainingProgCategory = schedule.trainingProgCategory;
                      row.trainingLocation = schedule.trainingLocation;
                      row.trainingSlot = schedule.trainingSlot;
                      row.start = schedule.fromDate.concat(" ").concat(schedule.fromTime);
                      row.endData = schedule.toDate.concat(" ").concat(schedule.toTime);
                      row.isPartOfPattern = (schedule.isPartOfPattern == 'Y' ? 'YES' : 'NO');
                      row.trainingProgram = schedule.trainingProgram;
                      row.subProgramCode = schedule.subProgramCode;
                    }

                    // Add trainer and trainee details using Cartesian product
                    if (trainers.length > 0 && trainees.length > 0) {
                      // Cartesian product: each trainer with each trainee
                      var trainerIndex = Math.floor(j / trainees.length);
                      var traineeIndex = j % trainees.length;

                      var trainer = trainers[trainerIndex];
                      row.trainerHub = trainer.otherHub || trainer.employerHub || '';
                      row.trainerId = trainer.crewId || '';
                      row.trainerCrewType = trainer.crewType || '';
                      row.trainersNames = trainer.crewName || '';

                      var trainee = trainees[traineeIndex];
                      row.traineeHub = trainee.otherHub || trainee.employerHub || '';
                      row.traineeId = trainee.crewId || '';
                      row.traineeCrewType = trainee.crewType || '';
                      row.traineesList = trainee.crewName || '';
                    } else if (trainers.length > 0) {
                      // Only trainers, no trainees
                      var trainer = trainers[j];
                      row.trainerHub = trainer.otherHub || trainer.employerHub || '';
                      row.trainerId = trainer.crewId || '';
                      row.trainerCrewType = trainer.crewType || '';
                      row.trainersNames = trainer.crewName || '';
                    } else if (trainees.length > 0) {
                      // Only trainees, no trainers
                      var trainee = trainees[j];
                      row.traineeHub = trainee.otherHub || trainee.employerHub || '';
                      row.traineeId = trainee.crewId || '';
                      row.traineeCrewType = trainee.crewType || '';
                      row.traineesList = trainee.crewName || '';
                    }

                    // Add observer details - cycle through observers if there are fewer observers than rows
                    if (observers.length > 0) {
                      var observerIndex = j % observers.length;
                      var observer = observers[observerIndex];
                      row.observerHub = observer.otherHub || observer.employerHub || '';
                      row.observerId = observer.crewId || '';
                      row.observerCrewType = observer.crewType || '';
                      row.observerList = observer.crewName || '';
                    }

                    vm.resultList.push(row);
                    currentRowIndex++;
                  }
                }

                return mergeInfo;
              };

              function clearData(){
                vm.resultList = [];
              }

              vm.onNameHower = function (e, trainer) {
                // console.log("on hower called ");
                vm.expiries = [];
                if(!!trainer.expiries && trainer.expiries.length !== 0) {
                  vm.expiries = trainer.expiries;
                  // console.log("on hower called in expires");
                  // console.log(vm.expiries);
                  var findCheckPosition = function () {
                    var H = 'left', V = 'top';
                    if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                      H = 'left';
                    } else {
                      H = 'right';
                    }
                    if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                      V = 'bottom';
                    } else {
                      V = 'top';
                    }
                    return H + '-' + V;
                  };
                  vm.toolTipPosition = findCheckPosition();
                }
              }

            },
            bindings: {
                trainingSchedule :'<',
                searchParam :'<',
                startPosition:'<',
//                pageSize:'<',
                totalRecords:'<',
                startIndex:'<',
                selectedRecord:'=',
                loadTrainingCategory:'&',
                deleteTraining:'&'
            }
        });
})();
